import {
  Accordion,
  Badge,
  Box,
  Card,
  Center,
  Divider,
  Group,
  ScrollArea,
  Skeleton,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import React, { memo, useCallback, useMemo, useRef, useState } from "react";

import { FixedSizeGrid } from "react-window";
import ReactVirtualizedAutoSizer from "react-virtualized-auto-sizer";
import { IconCamera } from "@tabler/icons-react";
import { logger } from "utils/logger";
import { pluralize } from "utils/helper";
import { TalentStatusTypes } from "core/models/TalentModel";
import ResolverImage from "core/components/resolverImage/ResolverImage";
import { useResizeObserver } from "@mantine/hooks";
import classes from "./TalentGridLayout.module.scss";
import { PrimaryBadge } from "core/components/badge/PrimaryBadge";

const TalentGridLayout = ({
  onImageEvent,
  thumbnailSize = 280,
  captures = [],
  selectedItems,
  onCaptureChange,
  showLoading,
  filter,
  onItemClick,
  onAccordionChange,
  displayPrefs,
}) => {
  // const imageHash = useRef({})
  logger.log(captures, showLoading);
  const [scrolled, setScrolled] = useState(false);
  const containerRef = useRef();
  const theme = useMantineTheme();
  const [ref, rect] = useResizeObserver();
  const isSelected = useCallback((val, selectedItems) => {
    let selected = false;
    if (selectedItems && val) {
      selected = selectedItems.find((item) => val.id === item.id)
        ? true
        : false;
    }
    return selected;
  }, []);

  const [selectedAccordion, setSelectedAccordion] = useState(
    displayPrefs?.selectedAccordion ?? []
  );

  function isEqual() {
    return false;
  }

  const ProxyCell = memo((props) => {
    const { columnIndex, rowIndex, style } = props;

    const ThumbCallback = useCallback(
      ({ columnIndex, data, rowIndex, style }) => {
        return (
          <div style={{ height: "100%", width: "100%", paddingLeft: 10 }}>
            <Box style={{ width: "100%", height: "100%" }}>
              <Skeleton width={"100%"} height={"80%"} />
              <Skeleton height={8} mt={10} radius="xl" />
              <Skeleton height={8} mt={5} width="70%" radius="xl" />
            </Box>
          </div>
        );
      },
      []
    );

    const tmpStyle = { ...style };
    return (
      <div key={`${columnIndex}-${rowIndex}`} style={tmpStyle}>
        <ThumbCallback {...props} />
      </div>
    );
  }, isEqual);

  const Cell = (props) => {
    const { columnIndex, data, rowIndex, style } = props;
    const idx = columnIndex + rowIndex * data.colCount;

    const items = data.collection ? data.collection : captures;
    var val = items[idx];
    logger.log(val, " ITEMS");
    if (!data.colCount) {
      val = items.find((val) => val.id === data.id);
      // val = val.original;
    } else if (val) {
      // val = val.original;
    }
    logger.log(idx, " ITEMS");
    // let guideInfo = getGuideInfo(val?.guideID, val?.catId, guides);

    const ThumbCallback = useCallback(
      ({ columnIndex, data, rowIndex, style }) => {
        // var imageURL = data && data.preview ? data.preview : '';
        logger.log("DATA - ", data);

        const selected = isSelected(val, selectedItems);

        return (
          <div style={{ height: "100%", width: "100%" }}>
            {data ? (
              <Box mb={"xl"} mx={"xs"}>
                {/* <SelectableMediaItem
                                    checkboxPosition='top-left'
                                    initiallySelected={selected}
                                    onSelectionChange={(e) => {
                                        logger.log(e);
                                        onImageEvent(CaptureEventType.IMAGE_CLICK, data, e, !selected);
                                    }}> */}
                <Card pt={0} pb={"lg"}>
                  <React.Fragment>
                    <Card.Section className={classes.imageWrapper}>
                      <ResolverImage
                        fit={"contain"}
                        height={300}
                        src={data.latestURL}
                        radius={"sm"}
                      />
                      {/* <Image
                        w="auto"
                        fit="contain"
                        height={300}
                        src={data.latestURL}
                        withPlaceholder
                        onClick={(e) =>
                          onImageEvent(
                            CaptureEventType.IMAGE_CLICK,
                            data,
                            e,
                            !isSelected(data, selectedItems)
                          )
                        }
                      /> */}
                      {/* <CaptureThumb
                                        showSettings={false}
                                        src={data.latestURL}
                                        image={data}
                                        resolvePath={false}
                                        onImageEvent={(type, data, originalEvent) => onImageEvent(type, data, originalEvent, !isSelected(data, selectedItems))}
                                        size={250}
                                        selected={isSelected(val, selectedItems)}
                                        onCaptureChange={(type, val) => onCaptureChange(type, val, [data])}
                                    /> */}
                    </Card.Section>
                    <Group justify="space-between" wrap={false} my="xs">
                      <Text fw={500} size={"md"} truncate>
                        {data.fullName}
                      </Text>

                      <div>
                        <Badge
                          color={
                            data.status &&
                            data.status === TalentStatusTypes.INACTIVE
                              ? "dark"
                              : "teal"
                          }
                          variant="light"
                        >
                          {data.status}
                        </Badge>
                      </div>
                    </Group>
                    <Divider />
                    <Card.Section py="xs" mx={0}>
                      <Group justify="space-between">
                        <Box>
                          <Text size="xs" c="dimmed">
                            Gender
                          </Text>

                          <Group>
                            {data.gender ? (
                              <Text size={"sm"}>{data.gender}</Text>
                            ) : (
                              <Text size={"sm"} color="dimmed">
                                -
                              </Text>
                            )}
                          </Group>
                        </Box>
                        <Group gap={"xs"}>
                          <Box>
                            <Text size="xs" c="dimmed">
                              Age
                            </Text>

                            <Group>
                              {data.age ? (
                                <Text size={"sm"}>{data.age}</Text>
                              ) : (
                                <Text size={"sm"} c="dimmed">
                                  -
                                </Text>
                              )}
                            </Group>
                          </Box>
                          <Box>
                            <Text size="xs" c="dimmed">
                              Height
                            </Text>

                            <Group>
                              {data.height ? (
                                <Text size={"sm"}>{data.height} cm</Text>
                              ) : (
                                <Text size={"sm"} c="dimmed">
                                  -
                                </Text>
                              )}
                            </Group>
                          </Box>
                        </Group>
                      </Group>
                      <Divider mt={"sm"} />
                      <Text mt={"md"} size="xs" c="dimmed" align="left">
                        Agency
                      </Text>

                      <Group position="left">
                        {data.agency ? (
                          <Text size={"sm"}>{data.agency}</Text>
                        ) : (
                          <Text size={"sm"} c="dimmed">
                            -
                          </Text>
                        )}
                      </Group>

                      <Group position="apart" mt={"md"}>
                        <Box>
                          <Text size="xs" c="dimmed" align="left">
                            Code
                          </Text>

                          <Group>
                            <Text size={"sm"}>{data.code}</Text>
                            {/* <Anchor
                              title="Show talent"
                              size="sm"
                              onClick={() => {
                                const tmpLoc = `${location.pathname}/${location.search}`;
                                setPreviousRoute(tmpLoc);
                                // navigate(`/talent/${data.talentSort}`);
                                onItemClick(data);
                              }}
                            >
                              <Text size={"sm"}>{data.code}</Text>
                            </Anchor> */}
                          </Group>
                        </Box>
                      </Group>
                    </Card.Section>
                  </React.Fragment>
                </Card>
                {/* </SelectableMediaItem> */}
              </Box>
            ) : (
              // <ResolverImage src={imageURL} />
              <div></div>
            )}
          </div>
        );
      },
      [val]
    );

    const tmpStyle = { ...style };
    return (
      <div key={`${columnIndex}-${rowIndex}`} style={tmpStyle}>
        <ThumbCallback {...props} data={val} />
        {/* <ResolverImage fit={'contain'} height={200} src={val?.thumb} /> */}
      </div>
    );
  };

  // const getLayout_table = () => {
  //     return (
  //         <Grid>
  //             {captures.map((val, idx) => {
  //                 return (
  //                     <Grid.Col key={idx} md={6} lg={2}>
  //                         <Cell data={val} style={{ height: '100%', width: '100%' }} />
  //                     </Grid.Col>
  //                 );
  //             })}
  //         </Grid>
  //     );
  // };

  function AccordionLabel(props) {
    const { name, image, descr, subRows } = props;
    return (
      <Group wrap="nowrap" grow>
        <Group justify="space-between">
          <Group>
            {!name || (name && !name.length) ? (
              <Title order={5} c={"dimmed"}>
                No Value
              </Title>
            ) : (
              <Title order={5}>{name}</Title>
            )}
          </Group>
          {/* <Badge variant="gradient" gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }}>{shots.length} Shots</Badge> */}
          {subRows ? (
            <PrimaryBadge>
              {subRows.length} {pluralize("Asset", subRows.length)}
            </PrimaryBadge>
          ) : null}

          {/* <Text size="sm" color="dimmed" weight={400}>
              {shots.length}
          </Text> */}
        </Group>
      </Group>
    );
  }

  const getLayout = useMemo(() => {
    const seenIds = new Set();
    if (filter && filter.groupBy) {
      return (
        <>
          <Accordion
            value={selectedAccordion}
            onChange={(val) => {
              setSelectedAccordion([...val]);
              onAccordionChange(val);
            }}
            variant="contained"
            chevronPosition="left"
          >
            {captures
              .filter((item, idx) => {
                const itemId = item.id.split(".")[0];
                if (itemId !== undefined && !seenIds.has(itemId)) {
                  seenIds.add(itemId);
                  return true;
                }
                return false;
              })
              .map((item, idx) => {
                // const colWidth = thumbnailSize < 180 ? 190 : thumbnailSize + 40;
                // const rowHeight =
                //   thumbnailSize < 180 ? 260 : thumbnailSize + 280;

                // const panels =
                //   document.getElementsByClassName("body-panels")[0];
                // let width = panels ? panels.offsetWidth - 100 : 500;
                // let colCount = Math.floor(width / colWidth);
                // let rowCount = showLoading
                //   ? 4
                //   : Math.floor(item.subRows.length / colCount);

                // if ((item.subRows.length / colCount) % 2) {
                //   ++rowCount;
                //   // ++colCount;
                // }

                // const height = rowCount * rowHeight;

                // const colWidth = thumbnailSize < 180 ? 190 : thumbnailSize + 50;
                // let rowHeight = thumbnailSize < 180 ? 260 : thumbnailSize + 335;

                const panels =
                  document.getElementsByClassName("body-panels")[0];
                let panelwidth = panels ? panels.offsetWidth - 120 : 500;
                // let colCount = Math.floor(panelwidth / colWidth);
                // // let rowCount = showLoading ? 4 : Math.floor(item.subRows.length / colCount);
                // let rowCount = Math.ceil(item.subRows.length / colCount);
                // // if ((item.subRows.length / colCount) % 2) {
                //     ++rowCount;
                //     // ++colCount;
                // }

                const colWidth = thumbnailSize < 180 ? 190 : thumbnailSize + 0;
                // let rowHeight = thumbnailSize < 180 ? 260 : thumbnailSize + 285;

                // let colCount = Math.floor(panelwidth / colWidth);
                // let rowCount = showLoading
                //   ? 8
                //   : Math.floor(captures.length / colCount);

                // if ((captures.length / colCount) % 2) {
                //   ++rowCount;
                //   // ++colCount;
                // }

                // const panelHeight = rowCount * rowHeight;

                return (
                  <Accordion.Item
                    style={{ border: 0 }}
                    value={idx.toString()}
                    key={idx}
                  >
                    <Accordion.Control
                      onClick={(e) => e.stopPropagation()}
                      className={classes.accordionControl}
                      style={
                        {
                          // borderTopColor:scrolled?'transparent':'-moz-initial'
                          // borderRadius:0,
                          // borderTopWidth: scrolled ? 1 : 0,
                          // borderTopColor:
                          //   theme.colorScheme === "dark"
                          //     ? theme.colors.dark[4]
                          //     : theme.colors.gray[3],
                        }
                      }
                    >
                      <AccordionLabel {...item} />
                    </Accordion.Control>
                    <Accordion.Panel className={classes.accordionPanel}>
                      <Group gap={0}>
                        {item?.subRows?.map((capture, idx) => {
                          return (
                            <div key={idx} style={{ width: colWidth }}>
                              <AccordionCell data={capture} />
                            </div>
                          );
                        })}
                      </Group>
                      {/* <FixedSizeGrid
                        columnCount={colCount}
                        columnWidth={panelwidth / colCount}
                        // columnWidth={index => columnWidths[index]}
                        height={panelHeight}
                        rowCount={rowCount}
                        rowHeight={rowHeight}
                        width={panelwidth + 25}
                        itemData={{
                          colCount: colCount,
                          rowCount: rowCount,
                          collection: item.subRows,
                          items: captures,
                        }}
                      >
                        {TalentCell}
                      </FixedSizeGrid> */}
                    </Accordion.Panel>
                  </Accordion.Item>
                );
              })}
          </Accordion>
        </>
      );
    } else {
      return (
        <ReactVirtualizedAutoSizer>
          {({ height, width }) => {
            const tmpWidth = width - 25;
            const colWidth = thumbnailSize < 180 ? 190 : thumbnailSize + 0;
            let rowHeight = thumbnailSize < 180 ? 260 : thumbnailSize + 285;

            let colCount = Math.floor(tmpWidth / colWidth);
            let rowCount = showLoading
              ? 8
              : Math.floor(captures.length / colCount);

            if ((captures.length / colCount) % 2) {
              ++rowCount;
              // ++colCount;
            }
            //rowCount = (captures.length/colCount)%2?rowCount+1:rowCount;

            return (
              <>
                {showLoading ? (
                  <FixedSizeGrid
                    columnCount={colCount}
                    columnWidth={tmpWidth / colCount}
                    height={height}
                    rowCount={rowCount}
                    rowHeight={rowHeight}
                    width={tmpWidth}
                    itemData={{ colCount, rowCount }}
                  >
                    {ProxyCell}
                  </FixedSizeGrid>
                ) : (
                  <FixedSizeGrid
                    columnCount={colCount}
                    columnWidth={tmpWidth / colCount}
                    height={height}
                    rowCount={rowCount}
                    rowHeight={rowHeight}
                    width={tmpWidth + 25}
                    itemData={{ colCount, rowCount }}
                  >
                    {Cell}
                  </FixedSizeGrid>
                )}
              </>
            );
          }}
        </ReactVirtualizedAutoSizer>
      );
    }
  }, [filter.groupBy, captures]);

  const content =
    !showLoading && captures.length === 0 ? <EmptyState /> : <>{getLayout}</>;
  return (
    // <Group spacing={'lg'}>

    //     {captures.map((val,idx) => (
    //         <ImageThumb key={idx} image={val} onImageEvent={onImageEvent} size={thumbnailSize} selected={isSelected(val,selectedItems)} />
    //     ))}

    // </Group>
    <ScrollArea
      ref={ref}
      className={[
        classes.scrollArea,
        filter && filter.groupBy ? classes.grouped : "",
      ]}
      style={{
        display: "flex",
        flexDirection: "column",
      }}
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
    >
      <Box
        ref={containerRef}
        style={{
          width: "100%",
          minHeight: "100%",
          marginLeft: 0,
        }}
      >
        {content}
      </Box>
    </ScrollArea>
  );
};

export default TalentGridLayout;

const EmptyState = () => {
  return (
    <Center style={{ height: "100%" }}>
      <div style={{ textAlign: "center" }}>
        <IconCamera size={48} stroke={1} />
        <Title color={"dimmed"} order={3}>
          No Assets Available
        </Title>
        <Text c={"dimmed"}>Try changing the Catalogue or Filter</Text>
      </div>
    </Center>
  );
};

const AccordionCell = ({ data, onImageClick, onItemClick }) => {
  if (!data) return null;

  return (
    <Box mb="xl" mx="xs">
      <Card pt={0} pb="lg">
        <Card.Section className={classes.imageWrapper}>
          <ResolverImage
            fit="contain"
            height={300}
            src={data.latestURL}
            radius="sm"
            onClick={(e) => onImageClick?.(e, data)}
          />
        </Card.Section>

        <Group justify="space-between" wrap={false} my="xs">
          <Text fw={500} size="md" truncate>
            {data.fullName}
          </Text>
          <Badge
            color={data.status === TalentStatusTypes.INACTIVE ? "dark" : "teal"}
            variant="light"
          >
            {data.status}
          </Badge>
        </Group>

        <Divider />

        <Card.Section py="xs" px={"md"}>
          <Group justify="space-between">
            <InfoField label="Gender" value={data.gender} />
            <Group gap={"lg"}>
              <InfoField label="Age" value={data.age} />
              <InfoField label="Height" value={data.height?`${data.height} cm`:'-'} />
            </Group>
          </Group>
          <Divider mt={'sm'} />
          <InfoField label="Agency" value={data.agency} mt="md" />

          <Group position="apart" mt="md">
            <InfoField label="Code" value={data.code} />
          </Group>
        </Card.Section>
      </Card>
    </Box>
  );
};

const InfoField = ({ label, value, mt }) => (
  <Box mt={mt || 0}>
    <Text size="xs" c="dimmed">
      {label}
    </Text>
    <Text size="sm" color={value ? "inherit" : "dimmed"}>
      {value || "-"}
    </Text>
  </Box>
);
